import { apiClient } from "./apiClient";
export const HINH_THUC_NOP_BOM_END_POINT = "sf_hinhthucnopbom";

export const hinhThucNopBomApi={
    selectAll : () => apiClient.get(`${HINH_THUC_NOP_BOM_END_POINT}`),
}